import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=6b69dcec&scoped=true&"
import script from "./CardTable.vue?vue&type=script&lang=ts&"
export * from "./CardTable.vue?vue&type=script&lang=ts&"
import style0 from "./CardTable.vue?vue&type=style&index=0&id=6b69dcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b69dcec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardTitle,VDataTable,VPagination,VSkeletonLoader})
